<template>
  <Upload ref="upload" :action="picurl" :headers="headers" :multiple="multiple" :max-size="maxSize" type="drag"
          :format="format" :accept="accept" :on-success="handleSuccess" :on-format-error="handleFormatError"
          :data="filedata"
          :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" :on-error="handleError"
          :on-preview="handelePreview" :on-remove="handeleRemove" :default-file-list="defaultlist">

    <div style="padding: 5px 0">
      <Icon v-if="!$slots.content" type="ios-cloud-upload" size="40" style="color: #3399ff"></Icon>
      <p v-if="!$slots.content">{{ $t('m.uplad_files') }}</p>
      <slot name="content"></slot>
    </div>
  </Upload>
</template>

<script>
export default {
  name: 'upload-music',
  props: {
    lists: Array,
    multiple: {
      type: Boolean,
      default: false
    },
    maxSize: {
      type: Number,
      default: null
    },
    format: Array,
    accept: {
      type: String,
      default: ''
    },
    //model:'',//模块 book_afterRead读后感  book书籍图片
    //filetype:'',//images（图片）、video（视频）、audio（音频）、file（文件）
    filedata: {
      type: [Boolean, Object],
      default: false
    },
    isExpert: {//名人数据库上传true 书籍上传false
      type: [Boolean, Object],
      default: false
    },
    //是否在列表上直接上传附件进行上传前判断
    isList_li:{
      type: [Boolean],
      default: false
    }
  },

  data() {
    return {
      headers: {
        Authorization: 'Bearer ' + (localStorage.token || '')
      },
      picurl: 'https://culture.aqitai.com/api/user/v1/uploadoss',
      defaultlist: this.lists,
      removlist: this.lists
    }
  },

  methods: {

    /*****************************************************************
     *
     * 上传文件之前的钩子，参数为上传的文件，若返回 false 或者 Promise 则停止上传
     *
     *****************************************************************/
    handleBeforeUpload(data) {
      if(this.isList_li){
        this.$emit('on-before-upload')
      }
      const check = this.multiple || this.$refs.upload.fileList.length < 1;
      if (!check) {
        this.$Notice.warning({
          title: '只能上传一个文件'
        });
      }
      return check;
    },

    /*****************************************************************
     *
     * 文件格式验证失败时的钩子，返回字段为 file, fileList
     * @param   {file}             单图
     * @param   {fileList}         单图
     *
     *****************************************************************/
    handleFormatError(file, fileList) {
      let size = (file.size / 1024 / 1024).toFixed(2)
      this.$Notice.warning({
        title: '文件格式不正确',
        desc: `
                    文件名：${file.name} <br>
                    文件类型：${file.type} <br>
                    文件大小：${size}M
                `,
        duration: 5
      });
    },

    /*****************************************************************
     *
     * 文件超出指定大小限制时的钩子，返回字段为 file, fileList
     * @param   {file}             单图
     * @param   {fileList}         单图
     *
     *****************************************************************/
    handleMaxSize(file, fileList) {
      let size = (file.size / 1024 / 1024).toFixed(2)
      this.$Notice.warning({
        title: '文件超出指定大小限制',
        desc: `
                    文件名：${file.name} <br>
                    文件类型：${file.type} <br>
                    文件大小：${size}M
                `,
        duration: 5
      });
    },

    /*****************************************************************
     *
     * 点击已上传的文件链接时的钩子，返回字段为 file， 可以通过 file.response 拿到服务端返回数据
     * @param   {file}             单图
     * @param   {fileList}         单图
     *
     *****************************************************************/
    handelePreview(file) {
      let url = file.response ? file.response.data.file_url : file.url
      // window.open(url)
    },

    /*****************************************************************
     *
     * 文件上传成功时的钩子，返回字段为 response, file, fileList
     * @param   {file}             单图
     * @param   {fileList}         单图
     * @param   {response}         单图
     *
     *****************************************************************/
    handleSuccess(response, file, fileList) {

      this.$Notice.success({title: '上传成功'})
      if(this.isExpert){//名人数据库哪里的文件上传和书籍不兼容需要这个区分开
        var arr = fileList.filter(el => {
          if (el.response){
            return el
          }else {
            return el
          }
        })
      }else {
        var arr = fileList.filter(el => {
          if (el.response) return el
        })
      }

      this.removlist = fileList.map(it=>{
        return it.response?it.response.data:it
      })


      this.$emit('on-upload', arr)
    },

    /*****************************************************************
     *
     * 文件上传失败时的钩子，返回字段为 error, file, fileList
     * @param   {file}             单图
     * @param   {fileList}         单图
     * @param   {error}            单图
     *
     *****************************************************************/
    handleError(error, file, fileList) {
      this.$Notice.error({title: '上传失败，请检查网路'})
    },

    /*****************************************************************
     *
     * 文件列表移除文件时的钩子，返回字段为 file, fileList
     * @param   {file}             单图
     * @param   {fileList}         单图
     *
     *****************************************************************/
    handeleRemove(file, fileList) {
      let that = this
      let index = that.removlist.findIndex(el =>file.response?(el.id===file.response.data.id):(el.id === file.id))
      fileList.splice(index, 0, file)
      that.defaultlist = fileList.map(it=>{
        return it.response?it.response.data:it
      })
      that.$emit('on-remove', that.defaultlist)

      that.$Modal.confirm({
        title: that.$t('m.del_info'),
        closable: true,
        loading: true,
        closable: false,
        content: that.$t('m.sure_del'),
        onOk: () => {
          that.$Modal.remove()
          if (file.used){
            that.delData(file, fileList)
          }else {
            let index = that.defaultlist.findIndex(el =>file.response?(el.id===file.response.data.id):(el.id === file.id))
            if (index >= 0) {
              that.removlist.splice(index, 1)
              that.defaultlist.splice(index, 1)
              that.$emit('on-remove', that.defaultlist)
            }
          }
          // that.$emit('on-remove', fileList)//在开发视频分类上传附件时出现了问题，如果其它地方不好使了，修改这块兼容

        }
      })

    },

    /************************************************************
     *
     * 删除文件
     *
     ************************************************************/
    async delData(data, fileList) {
      let that = this
      let params = {}
      if (data.delurl) {
        let cond = {
          table_name:data.table_name,
          table_key:data.table_key,
          table_keyid:data.table_keyid,
          model:data.model,
          quality:1,//文件种类 1原图(普清) 2压缩
          type:data.type,// 1文件 2图片3视频 4音频
          resources_id:data.id,//单独删除传，根据书籍删除时不传
          deltype:false,//用于内容信息列表中的删除true 单个删除资源fals
        }
        try {
          const res = await this.$httpsencrypt.post(data.delurl, cond)
          that.$Message.success('文件已删除')

          let index = that.defaultlist.findIndex(el =>data.response?(el.id===data.response.data.id):(el.id === data.id))
          if (index >= 0) {
            that.removlist.splice(index, 1)
            that.defaultlist.splice(index, 1)
            that.$emit('on-remove', that.defaultlist)
          }
        } catch (error) {
          that.$Message.warning('未能删除文件')
        }
      } else {
        params.url = `api/admin/v1/culture/moredel/${data.value}/${data.used}`
        try {
          const res = await that.$https.delete(params)
          that.$Message.success('文件已删除')
        } catch (error) {
          that.$Message.warning('未能删除文件')
        }
      }
    }
  },
  mounted() {
    if (typeof this.filedata == 'object') {
      this.$set(this.filedata, 'apiterminal', 'Aqt_20230517ApiWeb')
    }
  }
}
</script>
